<div class="col-12 d-flex flex-column content-sidebar">
    <div class="d-flex align-items-center justify-content-center pt-3 pb-3 col-12">
        <div class="divimg col-9">
            <img src="images/logo.png">
        </div>
    </div>
    <div class="col-12 d-flex align-items-center menu">
        <div class="d-flex flex-column align-items-center col-12 child-menu">
            <div class=" d-flex justify-content-center align-items-center p-3" (click)="changepage(item)" [ngClass]="page == item.id ? 'active':''" *ngFor="let item of listmenu">
                <i class="fa-solid" [ngClass]="item.icon"></i>
            </div>
        </div>
    </div>
</div>